import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useSavedCompanies from './favorites/useSavedCompanies';

const useIsCompanyFavorite = graphID => {
    const [isFavorite, setIsFavorite] = useState(false);
    const { data: savedCompanies } = useSavedCompanies();

    useEffect(() => {
        if (!graphID || !savedCompanies) {
            return;
        }

        const ids = savedCompanies.map(c => c.id);
        setIsFavorite(ids.includes(graphID));
    }, [graphID, savedCompanies]);

    return isFavorite;
};

useIsCompanyFavorite.propTypes = {
    graphID: PropTypes.string,
};

export default useIsCompanyFavorite;
